'use client';

import ButtonGradient from "@/components/ButtonGradient";
import { staticUrl } from "@/libs/cdn";
import fluentCityImg from "@/public/blog2/article2/de.jpg";
import Image from "next/image";
import type React from "react";
import { styles } from "../_assets/content";

const Article2: React.FC = () => {
  return (
    <>
      <Image
        src={fluentCityImg}
        alt=""
        width={700}
        height={500}
        priority={true}
        className="rounded-box"
        // placeholder="blur"
      />
      <section>
        <h3 className={styles.h3}>Warum das B1-Zertifikat wichtig ist?</h3>
        <p className={styles.p}>
          Übungstests helfen dabei, das Gelernte in realen Situationen anzuwenden. Sie simulieren echte Prüfungssituationen und geben einen Eindruck davon, was in der Prüfung gefragt wird. Außerdem helfen sie, Schwachstellen zu identifizieren, an denen man noch arbeiten kann, um die Prüfung sicher zu bestehen.
        </p>
      </section>

      <section>
        <h3 className={styles.h3}>Lade dein kostenloses Übungsheft herunter</h3>
        <p className={styles.p}>
          Wir bei Linpoly.com haben ein spezielles Übungsheft für die B1-Prüfung erstellt. Es enthält verschiedene Aufgaben, die dich auf die Prüfung vorbereiten und dir helfen, deine Fähigkeiten zu verbessern. Und das Beste: Du kannst dieses Übungsheft kostenlos herunterladen!
        </p>
        <p className="mt-10">
        <ButtonGradient 
          title="kostenlose herunterladen" 
          onClick={() => {
            const link = document.createElement('a');
            link.href = staticUrl("/workbooks/Linpoly-German-Workbook-B1.pdf");
            link.setAttribute('download', 'Linpoly-German-Workbook-B1.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }} 
        />
        </p>
      </section>

      <section>
        <h3 className={styles.h3}>Mehr Übung – Mehr Erfolg</h3>
        <p className={styles.p}>
          Das Übungsheft ist nur der Anfang! Mit Linpoly.com kannst du unendlich viele individuelle Übungshefte und Aufgaben erstellen, die auf deine Bedürfnisse zugeschnitten sind. Egal, ob es um Grammatik, Schreiben oder Leseverständnis geht – wir bieten dir die passenden Aufgaben, damit du optimal vorbereitet bist.
        </p>
      </section>
    </>
  );
};

export default Article2;